import type { CSSProperties } from "react";

import type { Addendum } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";
import { Divider2 } from "@/ui2/atoms/Divider";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { SignatureList } from "@/features/notes/(v2)/components/(signature)/SignatureList";

import { AddendumStateBadge } from "./AddendumStateBadge";

type AddendumDisplayProps = {
  addendum: Addendum;
  style?: CSSProperties;
  textTestId?: string;
};

export function AddendumDisplay({ addendum, style, textTestId }: AddendumDisplayProps) {
  const {
    addendum: text,
    addendum_state,
    cosigned_by,
    credentials,
    is_cosign_required,
    signature,
    timestamp,
  } = addendum;

  const signatureDate = timestamp ? dayjs.unix(timestamp).format("MM/DD/YYYY") : undefined;

  const isComplete = addendum_state === "complete";

  return (
    <div className="tw:flex tw:flex-col tw:gap-6" style={style}>
      <p className="body-md" {...getAutomationDataAttr(textTestId)}>
        {text}
      </p>

      {(signature || cosigned_by || signatureDate) && (
        <>
          <Divider2 />

          <SignatureList
            cosignatureBadge={
              !isComplete ? <AddendumStateBadge state={addendum_state} /> : undefined
            }
            cosignedBy={isComplete ? cosigned_by : undefined}
            credentials={credentials}
            isCosignRequired={is_cosign_required}
            isNoteComplete={isComplete}
            signature={signature}
            signatureDate={signatureDate}
            testId="note-addendum-footer"
          />
        </>
      )}
    </div>
  );
}
